module.exports = __webpack_public_path__ + "img/IOT2.47de8583.png";